import React from 'react';
import {SwipeableDrawer, useMediaQuery, useTheme} from '@mui/material';

const drawerBleeding = 160;

export function AuthDrawer({children}: {children: React.ReactNode}) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const isBigScreen = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open || isBigScreen}
      onClose={() => {
        setOpen(false);
      }}
      onOpen={() => setOpen(true)}
      swipeAreaWidth={drawerBleeding}
      disableSwipeToOpen={false}
      hideBackdrop
      elevation={0}
      disableEnforceFocus
      ModalProps={{
        keepMounted: true,
      }}
      PaperProps={{
        sx: {
          background: 'none',
          px: 2,
          overflow: 'visible',
          maxWidth: '488px',
          mx: 'auto',
        },
      }}
    >
      {children}
    </SwipeableDrawer>
  );
}
